<template lang="pug">
  div

    v-layout.my-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

    .content-layout(v-else)
      v-card(outlined)
        v-layout.ma-0.py-6(v-if="paymentMethods.length == 0")
          div.mx-auto.text-center
            v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
            p.caption {{ $t('no_method_added') }}
        v-simple-table(v-else fixed-header)
          template(v-slot:default)
            thead
              tr
                th.text-left.s2.primary400--text(style="background-color: #f7f7f7" colspan="2") {{ $t('payment_method') }}
            tbody
              tr(v-for="(paymentMethod, index) in paymentMethods" :key="paymentMethod.id")
                td.py-2.pr-0
                  div.s2.default--text {{ paymentMethod.name }}
                td.py-2.pl-0.pr-2(align="right")
                  v-btn.mr-3(icon small @click="clickDeletePaymentMethod(paymentMethod)")
                    eva-icon(name ="trash-outline" :fill="$vuetify.theme.themes[$theme].danger")
      v-layout.mt-4.mb-2
        v-btn.my-auto.ml-2.info500--text.button-Aa-small( depressed small color="white" height=20 @click="openAddPaymentMethodDialog = true")
          v-icon.ml-n2(left size=14) mdi-plus
          div.ml-n2.mr-n1  {{ $t('add_payment_method') }}

    .modals
      add-payment-method(v-if="openAddPaymentMethodDialog" :open.sync="openAddPaymentMethodDialog" :company="company" @refresh="fetchPaymentMethods")
      y-dialog(v-model='openRemovePaymentMethodDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('remove_payment_method') }}
          v-card-text.p2.primary500--text.px-4
            div {{ $t('remove_payment_method_confirmation') }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openRemovePaymentMethodDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='danger500' depressed height=32 @click='startDelete' :loading="isLoading" dark)
              .button-AA-small.basic100--text {{ $t('delete') }}

</template>

<script>
import { mapActions } from 'vuex'
import AddPaymentMethod from '@/components/restaurant/dialogs/AddPaymentMethod.vue'

export default {
  name: 'CounterPaymentList',
  components: { AddPaymentMethod },
  props: ['company'],
  data: () => ({
    isFetching: true,
    isLoading: false,
    openAddPaymentMethodDialog: false,
    openRemovePaymentMethodDialog: false,
    paymentMethods: [],
    deletePaymentMethod: null
  }),
  mounted () {
    this.isFetching = true
    this.fetchPaymentMethods()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickDeletePaymentMethod(paymentMethod) {
      this.openRemovePaymentMethodDialog = true
      this.deletePaymentMethod = paymentMethod
    },
    fetchPaymentMethods () {
      this.$axios.get(`/pos/${this.company.slug}/payment_methods`)
        .then((response) => {
          this.paymentMethods = response.data.results
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    startDelete() {
      this.isLoading = true
      this.axios.delete(`/pos/${this.company.slug}/payment_methods/${this.deletePaymentMethod.id}/`)
        .then(() => {
          this.paymentMethods = this.paymentMethods.filter((x) => x !== this.deletePaymentMethod)
          this.openRemovePaymentMethodDialog = false
          this.deletePaymentMethod = null
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "no_method_added": "No payment method added yet",
    "remove_payment_method": "Remove payment method",
    "remove_payment_method_confirmation": "Deleted method cannot be restored. Are you sure you would like to delete?"
  },
  "id": {
    "no_method_added": "Belum ada cara pembayaran yang ditambahkan",
    "remove_payment_method": "Remove payment method",
    "remove_payment_method_confirmation": "Deleted method cannot be restored. Are you sure you would like to delete?"
  }
}
</i18n>

